import React from 'react'

import LabelValue from '../../../../components/pdf/LabelValue'
import { getReason } from '../../../../utils/helpers/events'
import Separator from '../../../../components/pdf/Separator'
import Gallery from '../../../../components/pdf/Gallery'

const StatusReasonLabelValue = ({ serviceOrder }) => {
  const reason = getReason(serviceOrder)
  if (!reason) return false

  const { description, minicrudName, document } = reason
  let value = description
  if (minicrudName) value = `${minicrudName}: ${value}`

  return (
    <LabelValue label="Motivo" value={value}>
      {!!document && (
        <>
          <Separator weight={4} />
          <Gallery items={[document]} />{' '}
        </>
      )}
    </LabelValue>
  )
}

export default StatusReasonLabelValue
